import router from '../../router'

import {
  LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, AUTHORIZE, AUTHORIZE_SUCCESS, AUTHORIZE_FAILURE, AUTH_CLEAR,
  CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE, CLEAR_AUTH_STATUS,
  CHANGE_SHOP, CHANGE_SHOP_SUCCESS, CHANGE_SHOP_FAILURE, CANNOT_USE, NOTIFICATION_ADD,
  PASSWORD_RESET_MAIL_SEND, PASSWORD_RESET_MAIL_SEND_SUCCESS, PASSWORD_RESET_MAIL_SEND_FAILURE,
  PASSWORD_RESET_UPDATE, PASSWORD_RESET_UPDATE_SUCCESS, PASSWORD_RESET_UPDATE_FAILURE
} from './mutation-types'

export default {
  state: {
    user: {
      userId: null,
      userType: null,
      shopId: null,
      loginId: null,
      name: null,
      error: '',
      status: null,
      keepLogin: true,
      shopName: null
    },
    saveUserId: function (userId) {
      if (userId) {
        this.user.userId = userId
        window.localStorage.setItem('user_id', userId)
      }
    },
    saveShop: function (shopId, shopName) {
      if (shopId) {
        this.user.shopId = shopId
        window.localStorage.setItem('shop_id', shopId)
      } else {
        this.user.shopId = null
        window.localStorage.setItem('shop_id', null)
      }
      this.user.shopName = shopName
    }
  },
  getters: {
    authStatus: state => {
      return state.user.status
    },
    authError: state => {
      return state.user.error
    },
    currentUserType: state => {
      var userType = state.user.userType
      if (!userType) {
        userType = window.localStorage.getItem('user_type')
      }
      return userType
    },
    currentShopId: state => {
      var shopId = state.user.shopId
      if (!shopId && window.localStorage.getItem('shop_id') !== 'null') {
        shopId = window.localStorage.getItem('shop_id')
        state.user.shopId = shopId
      }
      return shopId
    },
    currentShopName: state => {
      return state.user.shopName
    },
    isLogin: state => {
      return state.user.userId !== null
    },
    userLoginId: state => {
      return state.user.loginId
    },
    userId: state => {
      var userId = state.user.userId
      if (!userId && window.localStorage.getItem('user_id') !== 'null') {
        userId = window.localStorage.getItem('user_id')
        state.user.userId = userId
      }
      return userId
    },
    userName: state => {
      return state.user.name
    }
  },
  actions: {
    [LOGIN] ({dispatch, state, commit}, params) {
      state.user.keepLogin = params.keepLogin
      dispatch('apiPost', {url: '/login', data: params.data})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(LOGIN_FAILURE, res.data)
          } else {
            commit(LOGIN_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CHANGE_PASSWORD] ({dispatch, state, commit}, params) {
      state.user.status = null
      dispatch('apiPatch', {url: '/account_update', data: params.data})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(CHANGE_PASSWORD_FAILURE, res.data)
          } else {
            commit(CHANGE_PASSWORD_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [AUTHORIZE] ({dispatch, state, commit}, params) {
      if (window.localStorage.getItem('keep_limit') && parseInt(window.localStorage.getItem('keep_limit')) !== 0) {
        var date = new Date()
        var now = date.getTime()

        if (now > parseInt(window.localStorage.getItem('keep_limit'))) {
          commit(LOGOUT)
        } else {
          var keepLimit = date.getTime() + 1800000
          window.localStorage.setItem('keep_limit', keepLimit)
        }
      }

      dispatch('apiGet', {url: '/login/current_user_info'})
      .then(res => {
        if (res.status === 200) {
          if (res.data.error) {
            commit(AUTHORIZE_FAILURE, res.data)
          } else {
            commit(AUTHORIZE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [LOGOUT] ({ commit }) {
      commit(LOGOUT)
    },
    [CLEAR_AUTH_STATUS] ({ state }) {
      state.user.status = null
    },
    [CHANGE_SHOP] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        state.user.status = null
        dispatch('apiPost', {url: '/select_shops/change', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200) {
            if (res.data.error) {
              commit(CHANGE_SHOP_FAILURE, res.data)
              dispatch(NOTIFICATION_ADD, {
                data: {
                  danger: true,
                  message_direct: res.data.error
                }
              })
              reject()
            } else {
              commit(CHANGE_SHOP_SUCCESS, {data: res.data, params: params})
              dispatch(NOTIFICATION_ADD, {
                data: {
                  success: true,
                  message_i18n: 'shop_list.shop_changed'
                }
              })
              resolve(res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [CANNOT_USE]  ({ commit }) {
      commit(CANNOT_USE)
    },
    [PASSWORD_RESET_MAIL_SEND] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        state.user.status = null
        dispatch('apiPost', {url: '/reset_password/send_mail', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200) {
            if (res.data.error) {
              commit(PASSWORD_RESET_MAIL_SEND_FAILURE, res.data)
              reject()
            } else {
              commit(PASSWORD_RESET_MAIL_SEND_SUCCESS, res.data)
              resolve()
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [PASSWORD_RESET_UPDATE] ({dispatch, state, commit}, params) {
      return new Promise((resolve, reject) => {
        state.user.status = null
        dispatch('apiPost', {url: '/reset_password/reset', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200) {
            if (res.data.error) {
              commit(PASSWORD_RESET_UPDATE_FAILURE, res.data)
              reject()
            } else {
              commit(PASSWORD_RESET_UPDATE_SUCCESS, res.data)
              resolve()
            }
          }
        })
        .catch(error => {
          throw error
        })
      })
    },
    [AUTH_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(AUTH_CLEAR)
      }, sleep)
    }
  },
  mutations: {
    [LOGIN_FAILURE] (state, data) {
      state.user.error = data.error
    },
    [LOGIN_SUCCESS] (state, data) {
      state.user.error = ''
      state.saveUserId(data.data.id)
      state.user.userType = data.data.attributes['user-type']
      window.localStorage.setItem('user_type', data.data.attributes['user-type'])
      state.user.loginId = data.data.attributes['login-id']
      window.localStorage.setItem('access_token', data.data.attributes['houkokusyo-access-token'])
      var keepLimit = 0
      if (!state.user.keepLogin) {
        var date = new Date()
        keepLimit = date.getTime() + 1800000
      }
      window.localStorage.setItem('keep_limit', keepLimit)
      state.user.name = data.data.attributes['name']
      state.saveShop(data.data.attributes['shop-id'], data.data.attributes['shop-name'])
      router.push('/')
    },
    [CHANGE_PASSWORD_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [CHANGE_PASSWORD_SUCCESS] (state, data) {
      state.user.status = 'success'
    },
    [AUTHORIZE_FAILURE] (state, data) {
      state.user.error = data.error
      router.push('/login')
    },
    [AUTHORIZE_SUCCESS] (state, data) {
      state.saveUserId(data.data.id)
      state.user.userType = data.data.attributes['user-type']
      window.localStorage.setItem('user_type', data.data.attributes['user-type'])
      state.user.loginId = data.data.attributes['login-id']
      window.localStorage.setItem('access_token', data.data.attributes['houkokusyo-access-token'])
      state.user.name = data.data.attributes['name']
      state.saveShop(data.data.attributes['shop-id'], data.data.attributes['shop-name'])
    },
    [LOGOUT] (state) {
      state.user.userId = null
      state.user.userType = null
      state.user.shopId = null
      state.user.loginId = null
      state.user.name = null
      state.user.error = ''
      state.user.status = null
      state.user.keepLogin = true
      state.user.shopName = null
      window.localStorage.removeItem('access_token')
      window.localStorage.removeItem('shop_id')
      window.localStorage.removeItem('user_id')
      window.localStorage.removeItem('user_type')
      router.push('/login')
    },
    [CANNOT_USE] (state) {
      router.push('/')
    },
    [CHANGE_SHOP_FAILURE] (state, data) {
      state.user.error = data.error
    },
    [CHANGE_SHOP_SUCCESS] (state, {data, params}) {
      state.saveShop(params.data.shop_id, data.shop_name)
    },
    [PASSWORD_RESET_MAIL_SEND_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [PASSWORD_RESET_MAIL_SEND_SUCCESS] (state, {data, params}) {
      state.user.status = 'success'
    },
    [PASSWORD_RESET_UPDATE_FAILURE] (state, data) {
      state.user.error = data.error
      state.user.status = 'error'
    },
    [PASSWORD_RESET_UPDATE_SUCCESS] (state, {data, params}) {
      state.user.status = 'success'
    },
    [AUTH_CLEAR] (state) {
      state.user.error = ''
      state.user.status = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js